import React from 'react';
import './styles/Layout.css';
import UserStatus from './UserStatus';

const Header: React.FC = () => {
  return (
    // <header className="dashboard-header">
    //   {/* <div className="header-left"></div> */}
    //   {/* <div className="header-right"> */}
    //     {/* <UserStatus /> */}
    //   {/* </div> */}
    // </header>
    <div></div>
  );
};

export default Header;
